import { render, staticRenderFns } from "./VcClosingPopup.vue?vue&type=template&id=f6fe95ac&scoped=true"
import script from "./VcClosingPopup.vue?vue&type=script&lang=js"
export * from "./VcClosingPopup.vue?vue&type=script&lang=js"
import style0 from "./VcClosingPopup.vue?vue&type=style&index=0&id=f6fe95ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fe95ac",
  null
  
)

export default component.exports